import agenteIaImg from "@/assets/agente-ia.webp";

export default function AgenteIaSection() {
  return (
    <section className="ai-section" id="diferencial">
      <div className="ai-container">
        <div className="ai-copy">
          <span className="faq-tag">Diferencial</span>
          <h2 className="ai-title">
            360° não é slogan.<br />É a forma como trabalhamos.
          </h2>
          <p className="ai-text">
            A maioria das empresas resolve apenas uma parte do problema e deixa o restante sob sua responsabilidade. Nós atuamos em toda a sua operação: mídia paga, conteúdo, identidade visual, site e análise de dados, integrando todos esses elementos de forma estratégica. Afinal, de nada adianta gerar tráfego se a página não converte. E de nada adianta converter se a marca não possui posicionamento.
          </p>
        </div>
        <div className="ai-media">
          <img
            src={agenteIaImg}
            alt="Agente de IA"
            className="ai-video ai-video--zoom"
          />
        </div>
      </div>
    </section>
  );
}
